import { render } from "./Business.html?vue&type=template&id=d65bbb30&ts=true&external"
import script from "./Business.vue?vue&type=script&lang=ts"
export * from "./Business.vue?vue&type=script&lang=ts"

import "./Business.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__